import { render, staticRenderFns } from "./SalonGeneralForm.vue?vue&type=template&id=47e89d94"
import script from "./SalonGeneralForm.vue?vue&type=script&lang=ts"
export * from "./SalonGeneralForm.vue?vue&type=script&lang=ts"
import style0 from "./SalonGeneralForm.vue?vue&type=style&index=0&id=47e89d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports